import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import history from '~/services/history';
import { contactDPOFailure, contactDPORequest } from './actions';
import { contactDPOTypes } from './types';

function* signIn({ payload }: ReturnType<typeof contactDPORequest>) {
  const { contactDPO } = payload;

  try {
    yield call(api.post, '/lgpd/v1/tickets', contactDPO);

    history.push('/home');
  } catch (error) {
    yield put(contactDPOFailure());
  }
}

export default all([takeLatest(contactDPOTypes.CONTACT_DPO_RESQUEST, signIn)]);
